import React, { useEffect, useState } from "react";

import { HubTableTemplate } from "../../components";
import OrdersV2LineItemsTable from "./OrdersV2LineItemsTable";
import { FOUNDRIES } from "../../constants";
import { WarningDeleteDialog } from "../../dialogs";
import { useDeleteOrderById } from "../../hooks";
import CustomerOrderContextMenu from "../CustomerOrdersTable/CustomerOrderContextMenu";

const sortable = true;
const items = [
  {
    id: "customer",
    label: "Customer",
  },
  {
    id: "poNumber",
    label: "PO #",
    sortable,
  },
  {
    id: "total",
    label: "Total",
    sortable,
  },
  {
    id: "parts",
    label: "Parts",
  },
  {
    id: "status",
    label: "Status",
  },
  {
    id: "location",
    label: "Location",
  },
  {
    id: "createdAt",
    label: "Created At",
    sortable,
  },
];

const keys = [
  {
    value: "customer.name",
    variant: "blueBold",
    navigate: true,
    route: "customers",
    id: "customer.id",
  },
  {
    value: "poNumber",
    variant: "blueBold",
    navigate: true,
    route: "orders",
    id: "id",
  },
  {
    value: "total",
    isCurrency: true,
    defaultValue: 0,
  },
  {
    value: "parts",
    variant: "blueBold",
  },
  {
    value: "status",
  },
  {
    value: "location",
    CustomComponent: ({ item }) => FOUNDRIES?.find((f) => f?.id === item?.location)?.label || "",
  },
  {
    value: "createdAt",
    isDate: true,
  },
];

export const OrdersTable = ({ rows = [], meta = {}, hideCustomer = false }) => {
  const [deletingId, setDeletingId] = useState(false);
  const { mutate: deleteOrderById, isSuccess } = useDeleteOrderById();

  const handleClose = () => setDeletingId(false);
  const handleSubmit = () => deletingId && deleteOrderById(deletingId);

  useEffect(() => {
    isSuccess && handleClose();
  }, [isSuccess]);

  const HeaderItems = hideCustomer ? items?.filter((i) => i.id !== "customer") : items;
  const BodyKeys = hideCustomer ? keys?.filter((i) => i.id !== "customer.id") : keys;

  const headerProps = {
    items: HeaderItems,
    includeCheckbox: true,
    includeEnd: true
  };
  const bodyProps = {
    includeChevron: true,
    items: rows,
    keys: BodyKeys,
    RenderElement: OrdersV2LineItemsTable,
    ContextMenu: ({ item }) => (
      <CustomerOrderContextMenu
        id={item?.id}
        setDeletingId={setDeletingId}
      />
    )
  };
  const props = { headerProps, bodyProps, meta: meta };

  return (
    <>
      <HubTableTemplate id="OrdersTable" {...props} />
      <WarningDeleteDialog
        isOpen={!!deletingId}
        onClose={handleClose}
        onSubmit={handleSubmit}
        title="You are about to delete this order!"
      />
    </>
  );
};

export default OrdersTable;
